import { useContext } from 'react';
import { CommonContext, CommonContextProps } from '../provider/CommonContextProvider';

const useCommonContext = (): CommonContextProps => {
  return useContext(CommonContext);
};

export default useCommonContext;
